import React from 'react';
import NumberFormat from 'react-number-format';
import { LabelInput, NumberFormatInput } from './styles';

export const BRLCurrencyInput = ({
  value,
  label,
  onChange,
  hasPrefix = true,
  disabled = false,
  placeholder = 'R$',
}) => {
  return (
    <LabelInput>
      {label}
      <NumberFormatInput
        value={value && Number(value)}
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={2}
        fixedDecimalScale
        prefix={hasPrefix ? 'R$ ' : ''}
        disabled={disabled}
        placeholder={placeholder}
        allowNegative={false}
        onValueChange={onChange}
        isNumericString={false}
      />
    </LabelInput>
  );
};
